export const QUERY_KEY_CAMERAS = 'cameras'
export const QUERY_KEY_CAMERAS_LAST_SNAP = 'cameras-last-snap'
export const QUERY_KEY_CAMERAS_SNAPS_BY_TIME = 'cameras-snaps-by-time'
export const QUERY_KEY_CAMERAS_DASHBOARD = 'cameras-dashboard'